import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NomePaginaEnum } from '@core/models/nome-pagina.enum';
import { GrupoService } from '@core/services/grupo.service';
import { addFormControls } from '@shared/util/util';
import { filtrarOpcaoSemAcento } from '@shared/util/accent-insensitive-filter.util';

@Component({
  selector: 'app-grupo-vinculo',
  templateUrl: './grupo-vinculo.component.html',
  styleUrls: ['./grupo-vinculo.component.scss']
})
export class GrupoVinculoComponent  implements OnInit, OnChanges {

  @Input() form!: FormGroup;
  @Input() data: any;
  @Input() nomePagina!: NomePaginaEnum;

  grupoForm!: FormGroup;
  opcoesGrupos: any;
  nzFilterOption = filtrarOpcaoSemAcento;

  constructor(
    private fb: FormBuilder,
    private grupoService: GrupoService
  ) { }

  ngOnInit(): void {
    this.construirForm();
    this.fetchOptions();
  }

  construirForm() {
    const nomeObs = this.nomePagina + 'Grupos';
    addFormControls(this.form, {
      [nomeObs]: [''],
    });

    this.grupoForm = this.fb.group({
      grupos: []
    });

    this.grupoForm.valueChanges.subscribe(() => {
      this.emitirAlteracaoFormulario();
    });
  }

  emitirAlteracaoFormulario() {
    if (this.grupoForm.dirty) {
      const objEnvio = { ...this.grupoForm.getRawValue() };

      objEnvio.grupos = objEnvio.grupos.map((item: any) => {
        if (typeof item === 'object') {
          delete item.id
          return item;
        } else {
          return {
            idEntidade: this.data?.id ?? null,
            idGrupo: item
          };
        }
      });

      const nomeObs = this.nomePagina + 'Grupos';
      this.form.get(nomeObs)?.setValue(objEnvio.grupos);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.opcoesGrupos?.length) {
      this.setSelectedOption();
      return;
    }
    this.fetchOptions();
  }

  fetchOptions(): void {
    const tipo = "Vinculo";
    this.grupoService.combo(tipo).subscribe(options => {
      this.opcoesGrupos = options;
      this.setSelectedOption();
    });
  }

  setSelectedOption(): void {
    const nomeObs = this.nomePagina + 'Grupos';
    if(this.data) {
      const grupos = this.data[nomeObs];
      const modificarArray = grupos?.map((item: any) => { item.id = item.idGrupo; return item; });
      // console.log('modificarArray', modificarArray);
      this.grupoForm.patchValue({grupos: modificarArray});
    }
  }

  compareFn(a: any, b: any): boolean {
    if(a?.id) {
      return a?.id === b;
    }
    else {
      return a === b;
    }
  }
}
